// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1gwADsapJc4an0FdknLwmD","modeInfo":"_3BD3Vj3QUvhAHBYN39bJa","switchButton":"YtBUGeQRXa6LX4aXe8EBI"};